import styled from 'styled-components'
import { Card } from 'antd'

export default styled(Card)`
  border: none;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
`
